import { useMemo } from "react";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";

import contentKeys from "./contentKeys";

const useActiveContentKey = () => {
  const { activeContentKey } = useMemberToobarContext();

  const isActive = useMemo(() => {
    switch (activeContentKey) {
      case "contact":
      case "form":
      case "messageSent":
        return contentKeys.active;
      default:
        return contentKeys.inactive;
    }
  }, [activeContentKey]);

  return isActive;
};

const useIsActive = () => {
  const activeContentKey = useActiveContentKey();
  return activeContentKey !== contentKeys.inactive;
};

export { useActiveContentKey, useIsActive };
